module.exports = __webpack_public_path__ + "img/charisma.d6b6b3d.webp";